module.exports = __webpack_public_path__ + "assets/ic-twitch.c9a7bbd2.svg";